import type { PaginationState } from '@tanstack/react-table';
import type { SelectOption } from '@aus-platform/design-system';

export const GEOTAG_TABLE_PAGINATION_INITIAL_STATE: PaginationState = {
  pageIndex: 0,
  pageSize: 100,
};

export const GEOTAG_TABLE_PAGE_SIZE_OPTIONS: SelectOption<number>[] = [
  { value: 10000, label: '10000' },
  { value: 5000, label: '5000' },
  { value: 2000, label: '2000' },
  { value: 1000, label: '1000' },
  { value: 500, label: '500' },
  { value: 100, label: '100' },
];
